import { useEffect, useState } from 'react'
import { AcUnitOutlined, WaterDropOutlined } from '@mui/icons-material'
import { Box, Grid, Typography, useTheme } from '@mui/material'

import sensorImage from '../../../images/meet-sensor.svg'
import useStyles from '../index.styles'

const ANIMATION_START_DELAY = 500
const ICON_FADE_IN_DELAY = 200
const ICON_FADE_IN_DURATION = 500
const TITLE_SLIDE_DURATION = 700
const FIRST_FEATURE_DELAY = TITLE_SLIDE_DURATION + 200
const FEATURE_ANIMATION_DURATION = 500

const EASING = {
  BEZIER_IN_CUBIC: 'cubic-bezier(0.32, 0, 0.67, 0)', // https://easingwizard.com/#0b0v50019
  BEZIER_IN_OUT_CUBIC: 'cubic-bezier(0.66, 0, 0.34, 1)', // https://easingwizard.com/#0v5000e
}
const MeetSensorSlim = () => {
  const classes = useStyles
  const theme = useTheme()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const isVisibleTimeout = setTimeout(() => setIsVisible(true), ANIMATION_START_DELAY) // Start animation shortly after component mounts
    return () => clearTimeout(isVisibleTimeout)
  }, [])

  return (
    <>
      <Box sx={classes.imageContainer}>
        <img src={sensorImage} alt="" />
      </Box>

      <Grid container={true} sx={classes.slimOuterContainer}>
        <Grid
          container={true}
          sx={{
            gap: 0.5,
            opacity: isVisible ? 1 : 0,
            filter: isVisible ? 'none' : 'blur(4px)',
            transition: theme.transitions.create(['opacity', 'filter'], {
              duration: ICON_FADE_IN_DURATION,
              easing: EASING.BEZIER_IN_CUBIC,
              delay: ICON_FADE_IN_DELAY, // Start after the first slide-in animation has started a bit
            }),
          }}
        >
          <WaterDropOutlined sx={classes.useCaseIcon} />
          <AcUnitOutlined sx={classes.useCaseIcon} />
        </Grid>

        <Grid
          container={true}
          sx={{
            flexDirection: 'column',
            marginBottom: 6,
            gap: 1,
            marginTop: 1,
            transform: isVisible ? 'translateY(0)' : 'translateY(-64px)',
            transition: theme.transitions.create('transform', {
              duration: TITLE_SLIDE_DURATION,
              easing: EASING.BEZIER_IN_OUT_CUBIC,
            }),
          }}
        >
          <Typography variant="h4" sx={classes.slimMeetYourText}>
            Meet your
          </Typography>
          <Typography variant="h3" sx={classes.slimSensorNameText}>
            Defender Slim Sensor
          </Typography>
        </Grid>

        <Grid container={true} sx={classes.slimFeaturesContainer}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: '300',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(48px)',
              transition: theme.transitions.create(['transform', 'opacity'], {
                duration: FEATURE_ANIMATION_DURATION,
                easing: EASING.BEZIER_IN_OUT_CUBIC,
                delay: FIRST_FEATURE_DELAY, // Start after the first slide-in animation + a small delay
              }),
            }}
          >
            Detect Leaks
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: '300',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(48px)',
              transition: theme.transitions.create(['transform', 'opacity'], {
                duration: FEATURE_ANIMATION_DURATION,
                easing: EASING.BEZIER_IN_OUT_CUBIC,
                delay: FIRST_FEATURE_DELAY + FEATURE_ANIMATION_DURATION, // Animate in after the first feature animates in
              }),
            }}
          >
            Prevent Freezing
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: '300',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(48px)',
              transition: theme.transitions.create(['transform', 'opacity'], {
                duration: FEATURE_ANIMATION_DURATION,
                easing: EASING.BEZIER_IN_OUT_CUBIC,
                delay: FIRST_FEATURE_DELAY + FEATURE_ANIMATION_DURATION * 2, // Animate in after the second feature animates in
              }),
            }}
          >
            Stay Protected
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default MeetSensorSlim
